import React from 'react';
import { Button, Result } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { ResultStatusType } from 'antd/es/result';

interface ResultProps {
  status?: ResultStatusType;
  title?: string;
}

const ResultPage: React.FC<ResultProps> = (props) => {
    const navigate = useNavigate(); // Initialize the navigate function  
  const location = useLocation(); // Access the state passed via navigate
  const { status, title } = location.state || {}; // Destructure status and title from location.state

  return (
    <Result
      status={status as ResultStatusType}
      title={title || "Result"}
    extra={[
      <Button type="primary" key="console" onClick={() => navigate('/')}>
        Go Home 
      </Button >,
    ]}
  />
);
}

export default ResultPage;